import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useMemo, useRef, useContext } from 'react';
import isEqual from 'react-fast-compare';
import { useFieldArray } from './hooks/use-field-array';
import { uuid } from './utils';
import { isFunction } from 'lodash';
var FieldArrayContext = /*#__PURE__*/createContext();
var FieldArrayProvider = FieldArrayContext.Provider;

function FieldArray(_ref) {
  var name = _ref.name,
      initialValue = _ref.initialValue,
      sendImmediate = _ref.sendImmediate,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      validate = _ref.validate,
      children = _ref.children,
      render = _ref.render,
      rest = _objectWithoutProperties(_ref, ["name", "initialValue", "sendImmediate", "onFocus", "onChange", "onBlur", "validate", "children", "render"]);

  var id = useRef(uuid());

  var _useFieldArray = useFieldArray(name, _objectSpread({
    id: id.current,
    initialValue: initialValue,
    sendImmediate: sendImmediate,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur,
    validate: validate
  }, rest)),
      _useFieldArray2 = _slicedToArray(_useFieldArray, 2),
      fields = _useFieldArray2[0],
      actions = _useFieldArray2[1];

  var state = useMemo(function () {
    return _objectSpread(_objectSpread({}, actions), {}, {
      fields: fields
    });
  }, [actions, fields]);
  return /*#__PURE__*/React.createElement(FieldArrayProvider, {
    value: id.current
  }, isFunction(children) ? children(state) : isFunction(render) ? render(state) : children);
}

function useFieldArrayContext() {
  return useContext(FieldArrayContext);
}

export { useFieldArrayContext };
export default /*#__PURE__*/React.memo(FieldArray, isEqual);